import { abyssColors, primary } from '@/theme/colors';
import { CSS, Transform } from '@dnd-kit/utilities';
import { Menu, Stack, Typography, styled as muiStyled } from '@mui/material';

export const ZoneCard = muiStyled(Stack)(() => ({
  width: '100%',
  background: abyssColors.neutral[50],
  padding: '1.6rem',
  borderRadius: '0.4rem',
  border: `0.1rem solid ${abyssColors.neutral[100]}`,
}));

export const Name = muiStyled(Typography)(() => ({
  color: primary.independence,
  fontSize: '1.6rem',
  fontWeight: 500,
  lineHeight: '100%',
}));

export const Label = muiStyled(Typography)(() => ({
  color: abyssColors.primary[400],
  fontSize: '1.2rem',
  fontWeight: 400,
  lineHeight: '100%',
}));

export const selectStyles = {
  '.MuiSelect-select': {
    p: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    cursor: 'pointer',
  },
};

export const StyledButtonMenu = muiStyled(Menu)(() => ({
  marginTop: '1.4rem',

  '& .MuiPaper-root': {
    minWidth: '18.6rem',
    borderRadius: '0.4rem',
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.30)',
  },
  '& .MuiMenuItem-root': {
    gap: '0.4rem',
    padding: '0 1.2rem',
    fontSize: '1.2rem',
    display: 'flex',
    fontWeight: 400,
    alignItems: 'center',
    color: abyssColors.primary[500],
    '&:hover': {
      backgroundColor: abyssColors.neutral[50],
    },
  },
}));

interface DragAndDropStyleParams {
  transform: Transform | null;
  isDragging: boolean;
  isSelected: boolean;
}

export const dragAndDropStyle = ({
  transform,
  isDragging,
  isSelected,
}: DragAndDropStyleParams) => ({
  transform: CSS.Translate.toString(transform),
  opacity: isDragging ? 0.5 : 1,
  zIndex: isDragging ? 999 : 'auto',
  cursor: isDragging ? 'grabbing' : 'grab',
  border: isSelected ? `2px solid ${abyssColors.primary[500]}` : undefined,
  backgroundColor: isSelected ? `${abyssColors.primary[50]}` : undefined,
});
